/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alreadysubscribederror2Inputs */

const en_alreadysubscribederror2 = /** @type {(inputs: Alreadysubscribederror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are already subscribed to this plan.`)
};

const de_alreadysubscribederror2 = /** @type {(inputs: Alreadysubscribederror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast diesen Plan bereits abonniert.`)
};

/**
* | output |
* | --- |
* | "You are already subscribed to this plan." |
*
* @param {Alreadysubscribederror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const alreadysubscribederror2 = /** @type {((inputs?: Alreadysubscribederror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alreadysubscribederror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_alreadysubscribederror2(inputs)
	return de_alreadysubscribederror2(inputs)
});
export { alreadysubscribederror2 as "alreadySubscribedError" }